module.exports = __webpack_public_path__ + "images/Loader_Logo_2.gif";